































import ZastosowaniaForm from "./ZastosowaniaForm.vue";
import Vue from "vue";
import {
  Receptura,
  recepturaResource,
} from "@megarax/client/src/resources/plm/Receptura";
import IngredientsForm from "./IngredientsForm.vue";
import DefaultRevisionForm from "@/components/DefaultRevisionForm.vue";
import { createComponent } from "@vue/composition-api";
import { required } from "@/shared/validationRules";
import { formValidator } from "@/shared/formValidator";
import Decimal from "decimal.js";

const validationRules = {
  name: required,
  defaultMassKg: required,
};

export default createComponent({
  components: {
    ZastosowaniaForm,
    IngredientsForm,
    DefaultRevisionForm,
  },
  name: "RecepturaForm",
  props: {
    value: {
      type: Receptura,
      required: true,
    },
  },
  setup(props, ctx) {
    function onTotalMassKgChange(val: Decimal) {
      props.value.defaultMassKg = val;
    }

    return {
      ...formValidator(),
      validationRules,
      onTotalMassKgChange,
      resource: recepturaResource,
    };
  },
});
